"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __importDefault(require("./component"));
var package_json_1 = require("./package.json");
var install = function (app) {
    component_1.default.forEach(function (comp) {
        comp.install(app);
    });
};
exports.default = { install: install, version: package_json_1.version };
